import { ActionReducer } from '@ngrx/store';
import { logoutAction } from '../actions/auth.actions';

export function LogoutMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function(state, action) {
    if (action.type === logoutAction.type) {
      return reducer({} as any, { type: '' }); //reset the store
    }
    return reducer(state, action);
  };
}
